import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import type { FmProduct, FmVersion, FmMaterial } from "@shared/types";

export function useFormulationProducts() {
  return useQuery({
    queryKey: ["formulations", "parts"],
    queryFn: () => apiFetch<FmProduct[]>("/api/formulations/parts"),
    staleTime: Infinity,
  });
}

export function useFormulationVersions(productId: number | null) {
  return useQuery({
    queryKey: ["formulations", "versions", productId],
    queryFn: () =>
      apiFetch<FmVersion[]>(`/api/formulations/${productId}/versions`),
    enabled: productId !== null,
  });
}

export function useFormulationMaterials(formulationId: number | null) {
  return useQuery({
    queryKey: ["formulations", "materials", formulationId],
    queryFn: () =>
      apiFetch<FmMaterial[]>(`/api/formulations/${formulationId}/ingredients`),
    enabled: formulationId !== null,
  });
}
